<template>
  <div>
    <b-row :class="rowClass">
      <b-col>
        <b-button
          v-if="show"
          size="sm"
          @click="$emit('update:panel', panel === 'brands' ? null : 'brands')"
          :variant="filterActive ? 'danger' : 'primary'"
        >Brands</b-button>
        <slot name="buttons" />
      </b-col>
      <b-col sm="2">
        <slot name="search" />
      </b-col>
    </b-row>

    <div class="filter-panel" :class="[panelSpacing, { 'filter-panel-open': panel !== null }]">
      <div v-show="panel === 'brands'" class="filter-panel-content">
        <b-row class="mb-2">
          <b-col class="filter-col">
            <div class="filter-group-label">Brands</div>
            <b-form-checkbox-group
              :id="`${namePrefix}-brands-select`"
              :checked="selectedBrands"
              @input="$emit('update:selectedBrands', $event)"
              :options="brands"
              :name="`${namePrefix}-brands`"
              class="filter-checkbox-group"
            />
          </b-col>
          <b-col class="filter-col">
            <div class="filter-group-label">Types</div>
            <b-form-checkbox-group
              :checked="selectedModelTypes"
              @input="$emit('update:selectedModelTypes', $event)"
              :options="modelTypes"
              :name="`${namePrefix}-model-types`"
              class="filter-checkbox-group"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button size="sm" variant="secondary" @click="onAll">All</b-button>
            <b-button size="sm" variant="secondary" @click="$emit('invert')">Invert</b-button>
          </b-col>
        </b-row>
      </div>
      <slot name="extra-panel" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandsFilter',
  props: {
    panel:              { type: String,  default: null },
    filterActive:       { type: Boolean, default: false },
    brands:             { type: Array,   default: () => [] },
    selectedBrands:     { type: Array,   default: () => [] },
    modelTypes:         { type: Array,   default: () => [] },
    selectedModelTypes: { type: Array,   default: () => [] },
    namePrefix:         { type: String,  required: true },
    panelSpacing:       { type: String,  default: 'mt-2' },
    rowClass:           { type: String,  default: 'align-items-center' },
    show:               { type: Boolean, default: true },
  },
  methods: {
    onAll() {
      this.$emit('all');
    },
  },
};
</script>

<style scoped>
.filter-panel-content {
  border: 1px solid #dee2e6;
  border-radius: 0 0.25rem 0.25rem 0.25rem;
  padding: 0.75rem 1rem 0.5rem;
}
.filter-col {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.filter-checkbox-group {
  display: grid !important;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.35rem 0;
}
.filter-group-label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6c757d;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/BrandsFilter.vue